import React from 'react';
import styles from './index.module.scss';

const PulsingDot = () => {
  return (
    <div className={styles.loadingCircleContainer}>
      <div className={styles.pulseCircle2}></div>
      <div className={styles.pulseCircle1}></div>
    </div>
  );
};

export default PulsingDot;
